export default __webpack_public_path__ + "c3432220f657733ed05f2b9a092ce562.svg";